import { render, staticRenderFns } from "./CertificateTypesManagement.vue?vue&type=template&id=f0169b66&scoped=true"
import script from "./CertificateTypesManagement.vue?vue&type=script&lang=js"
export * from "./CertificateTypesManagement.vue?vue&type=script&lang=js"
import style0 from "./CertificateTypesManagement.vue?vue&type=style&index=0&id=f0169b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0169b66",
  null
  
)

export default component.exports